// extracted by mini-css-extract-plugin
export default {"melodyVideo":"SL-z","isFullWidth":"TL-z","landingPageVideo":"UL-z","play":"VL-z","iframeVideo":"WL-z","playHidden":"XL-z","fullwidth":"YL-z"};